const {
  default: environment
} = require('../env-config');
const cfg = require(`./config.js`)(environment);

let config = null;

const getConfiguration = () => {
  config = cfg;
  return config;
};

export const getEnv = () => {
  return config || getConfiguration();
}